import {
    FETCH_START,
    FETCH_END,
    FORMULA_LIST_SUCCESS,
    FORMULA_CREATE_SUCCESS,
    FORMULA_UPDATE_SUCCESS,
    FORMULA_DELETE_SUCCESS,
    FORMULA_BY_NAME_SUCCESS,
    FORMULA_VERSIONS_SUCCESS,
    FORMULA_VERSION_SUCCESS,
    FORMULA_CATEGORIES_SUCCESS,
    FORMULA_EXECUTE_SUCCESS,
    FORMULA_EXECUTE_VERSION_SUCCESS,
    FILTER_LIST_SUCCESS,
    FILTER_BY_GROUP_SOURCE_SUCCESS,
    FILTER_BY_ID_SUCCESS,
    FILTER_BY_NAME_SUCCESS,
    FILTER_CREATE_SUCCESS,
    FILTER_EXECUTE_SUCCESS,
    FORMULA_SIMULATE_SUCCESS,
    FILTER_UPDATE_SUCCESS,
    FORMULA_FUNCTIONS_SUCCESS,
    FILTER_DELETE_SUCCESS,
    QUERY_LIST_SUCCESS,
    QUERY_BY_ID_SUCCESS,
    QUERY_CREATE_SUCCESS,
    QUERY_UPDATE_SUCCESS,
    QUERY_DELETE_SUCCESS,
    QUERY_TEST_SUCCESS,
    QUERY_FUNCTIONS_SUCCESS,
    FORMULA_BY_ID_SUCCESS,
    GLOBAL_LIST_METADATA_SUCCESS,
    LOG_LIST_SUCCESS
} from '../../../actions/DesignerStudio/NewFormulaBuilder/ActionTypes';

const initialState = {
    loading: false,
    functions: [],
    formulaByName: null,
    formulaVersions: [],
    formulaVersion: null,
    formulaCategories: [],
    formulaExecutionResult: null,
    formulaExecutionVersionResult: null,
    executeResult: null,
    simulateResult: null,
    formulas: [],
    filters: [],
    selectedFilter: null,
    filterByName: null,
    filterByGroupSource: null,
    queries: [],
    queryData: null,
    queryTestResult: null,
    queryFunctions: [],
    formulaData: null,
    globalMetadata: [],
    logs: []
};

const NewFormulaBuilderReducer = (state = initialState, action) => {
    switch (action.type) {

        case FETCH_START:
            return { ...state, loading: true };

        case FETCH_END:
            return { ...state, loading: false };

        /* ---------- FORMULA ---------- */

        case FORMULA_LIST_SUCCESS:
            return { ...state, formulas: action.data };

        case FORMULA_CREATE_SUCCESS:
            return { ...state, formulas: [...state.formulas, action.data] };

        case FORMULA_UPDATE_SUCCESS:
            return {
                ...state,
                formulas: state.formulas.map(f =>
                    f.id === action.data.id ? action.data : f
                )
            };
        case FORMULA_BY_NAME_SUCCESS:
            return {
                ...state,
                formulaByName: action.data,
            };

        case FORMULA_VERSIONS_SUCCESS:
            return {
                ...state,
                formulaVersions: action.data,
            };

        case FORMULA_VERSION_SUCCESS:
            return {
                ...state,
                formulaVersion: action.data,
            };

        case FORMULA_CATEGORIES_SUCCESS:
            return {
                ...state,
                formulaCategories: action.data,
            };

        case FORMULA_EXECUTE_SUCCESS:
            return {
                ...state,
                formulaExecutionResult: action.data,
            };

        case FORMULA_EXECUTE_VERSION_SUCCESS:
            return {
                ...state,
                formulaExecutionVersionResult: action.data,
            };

        case QUERY_BY_ID_SUCCESS:
            return {
                ...state,
                queryData: action.data
            };

        case QUERY_CREATE_SUCCESS:
            return {
                ...state,
                queries: [...state.queries, action.data]
            };

        case QUERY_UPDATE_SUCCESS:
            return {
                ...state,
                queries: state.queries.map(q =>
                    q.id === action.data.id ? action.data : q
                )
            };

        case QUERY_DELETE_SUCCESS:
            return {
                ...state,
                queries: state.queries.filter(q => q.id !== action.data)
            };

        case QUERY_TEST_SUCCESS:
            return {
                ...state,
                queryTestResult: action.data
            };

        case QUERY_FUNCTIONS_SUCCESS:
            return {
                ...state,
                queryFunctions: action.data
            };
        case FORMULA_DELETE_SUCCESS:
            return {
                ...state,
                formulas: state.formulas.filter(f => f.id !== action.data)
            };
        case FORMULA_FUNCTIONS_SUCCESS:
            return {
                ...state,
                functions: action.data,
            };
        case FORMULA_BY_ID_SUCCESS:
            return {
                ...state,
                formulaData: action.data
            };

        /* ---------- FILTER ---------- */

        case FILTER_LIST_SUCCESS:
            return { ...state, filters: action.data };

        // `filters` holds the list response ({ success, data: [...], meta }), and
        // create/update responses wrap the record as { success, data: {...} }.
        case FILTER_CREATE_SUCCESS: {
            const created = action.data?.data ?? action.data;
            return {
                ...state,
                filters: { ...state.filters, data: [...(state.filters?.data || []), created] },
            };
        }
        case FILTER_BY_ID_SUCCESS:
            return {
                ...state,
                selectedFilter: action.data
            };

        case FILTER_BY_NAME_SUCCESS:
            return {
                ...state,
                filterByName: action.data
            };

        case FILTER_BY_GROUP_SOURCE_SUCCESS:
            return {
                ...state,
                filterByGroupSource: action.data
            };
        case FILTER_UPDATE_SUCCESS: {
            const updated = action.data?.data ?? action.data;
            return {
                ...state,
                filters: {
                    ...state.filters,
                    data: (state.filters?.data || []).map(f =>
                        f.ID === updated?.ID ? updated : f
                    ),
                },
            };
        }

        case FILTER_DELETE_SUCCESS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    data: (state.filters?.data || []).filter(f => f.ID !== action.data),
                },
            };
        case FILTER_EXECUTE_SUCCESS:
            return {
                ...state,
                executeResult: action.data,
            };
        case FORMULA_SIMULATE_SUCCESS:
            return {
                ...state,
                simulateResult: action.data,
            };
        /* ---------- QUERY ---------- */

        case QUERY_LIST_SUCCESS:
            return { ...state, queries: action.data };

        /* ---------- GLOBAL LIST ---------- */

        case GLOBAL_LIST_METADATA_SUCCESS:
            return { ...state, globalMetadata: action.data };

        /* ---------- LOGS ---------- */

        case LOG_LIST_SUCCESS:
            return { ...state, logs: action.data };

        default:
            return state;
    }
};

export default NewFormulaBuilderReducer;

